import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadFirebaseAuth } from '../firebaseAuthLazy.js';

const AuthContext = createContext({
  user: null,
  loading: true,
  isAdmin: false,
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Lazy load Firebase Auth only when AuthProvider mounts
    // This defers the 90KB Firebase Auth iframe until actually needed
    let unsubscribe = () => {};
    
    (async () => {
      try {
        const firebaseModule = await loadFirebaseAuth();
        const { onAuthStateChanged } = await import('firebase/auth');
        
        unsubscribe = onAuthStateChanged(firebaseModule.auth, (currentUser) => {
          setUser(currentUser || null);
          setLoading(false);
        });
      } catch (error) {
        console.error('[AuthContext] Failed to load Firebase Auth:', error);
        setLoading(false);
      }
    })();

    return () => unsubscribe();
  }, []);

  const isAdmin =
    !!user &&
    !user.isAnonymous &&
    typeof user.email === 'string' &&
    user.email.toLowerCase() === 'sivagundam20@gmail.com';

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

